import { SheetFooter } from '@/components/ui/sheet'
import { Skeleton } from '@/components/ui/skeleton'

export const TransferOwnershipFallback = () => {
  return (
    <>
      <div className="px-4 overflow-y-auto">
        <Skeleton className="h-[117px] w-full mb-8" />
        <Skeleton className="h-3 w-[190px] mb-2" />
        <div className="flex gap-2">
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-3.5 w-[120px]" />
        </div>
        <Skeleton className="h-3 w-[170px] mb-2 mt-6" />
        <Skeleton className="h-9 w-full mb-6" />
        <Skeleton className="h-3 w-[110px] mb-2 mt-6" />
        <Skeleton className="h-9 w-full mb-2" />
      </div>
      <SheetFooter className="sticky">
        <Skeleton className="h-9 w-full" />
      </SheetFooter>
    </>
  )
}
